import regularAppService from "./regularAppService";

let tagsCachePromise = null;

export const getTagsPage = async ({ page, limit, search, sortBy = "updatedAt", sortOrder = "desc" } = {}) => {
  const isValidSearch = typeof search === "string" && search.trim().length > 0;
  const result = await regularAppService.getPaginated({
    collection: "tags",
    ...(Number.isFinite(Number(page)) ? { page: Number(page) } : {}),
    ...(Number.isFinite(Number(limit)) ? { limit: Number(limit) } : {}),
    ...(isValidSearch ? { search } : {}),
    sortBy,
    sortOrder,
  });
  return result;
};

export const getTag = async () => {
  if (!tagsCachePromise) {
    tagsCachePromise = (async () => {
      const page = await regularAppService.getPaginated({ collection: "tags", page: 1, limit: 200 });
      return Array.isArray(page.items) ? page.items : [];
    })().catch((err) => {
      // Reset cache on failure so future calls can retry
      tagsCachePromise = null;
      throw err;
    });
  }
  return await tagsCachePromise;
};

export const createTag = async (tagData) => {
  
  const newTag = {
    ...tagData,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
  const result = await regularAppService.upsert({ collection: "tags", data: newTag });
  return result;
};

export const updateTag = async (tagData) => {
  const updatedTag = {
    ...tagData,
    updatedAt: new Date().toISOString(),
  };

  const result = await regularAppService.upsert({ collection: "tags", data: updatedTag });
  return result;
};

export const deleteTag = async (tagId) => {
  const deletedTag = {
    _id: tagId,
    deleted: true,
    updatedAt: new Date().toISOString(),
  };

  const result = await regularAppService.upsert({ collection: "tags", data: deletedTag });
  return result;
};

export const searchTags = async ({ search = "" }) => {
  const isValid = typeof search === "string" && search.trim().length > 0;
  const pageResult = await regularAppService.getPaginated({
    collection: "tags",
    ...(isValid ? { search } : {}),
  });
  return pageResult.items || [];
};

// Method to force a sync with the server
export const syncTags = async () => {
  return await getTag();
};

// Debugging function to reset and check tags data
export const debugTags = async () => {
  return [];
};
